export const homePl = {
  hero_title_1: 'Kakobuy Spreadsheet',
  hero_title_2: 'Polska 2026',
  hero_subtitle: 'Kompletny przewodnik po arkuszach produktowych Kakobuy. Znajdź najlepsze linki do produktów, poradniki zakupowe i sprawdzone arkusze kalkulacyjne dla polskich użytkowników.',
  category_title: 'Przeglądaj kategorie produktów',
  category_subtitle: 'Wybierz interesującą Cię kategorię i przejdź bezpośrednio do arkusza produktowego',
  brands_title: 'Popularne marki',
  brands_subtitle: 'Odkryj arkusze produktowe dla najpopularniejszych marek',
  about_label: 'O NAS',
  about_title_1: 'Twój zaufany',
  about_title_2: 'przewodnik po',
  about_title_3: 'Kakobuy Spreadsheet',
  about_desc_1: 'Kakobuy Spreadsheet Polska to niezależny przewodnik stworzony przez doświadczonych użytkowników platformy Kakobuy. Naszym celem jest dostarczanie najbardziej aktualnych i sprawdzonych linków do produktów.',
  about_desc_2: 'Regularnie aktualizujemy nasze arkusze, sprawdzamy jakość sprzedawców i testujemy nowe produkty, aby zapewnić Ci najlepsze doświadczenia zakupowe.',
  testimonial_tag: 'OPINIE',
  testimonial_title_1: 'Co mówią',
  testimonial_title_2: 'nasi użytkownicy',
  testimonial_text: 'Kakobuy Spreadsheet to najlepsze narzędzie jakie znalazłem do przeglądania produktów. Dzięki niemu zaoszczędziłem mnóstwo czasu na szukaniu sprawdzonych sprzedawców. Gorąco polecam każdemu kto dopiero zaczyna z Kakobuy!',
  testimonial_name: 'Marek Kowalski',
  testimonial_role: 'Użytkownik Kakobuy od 2024',
  cta_title: 'Gotowy na zakupy?',
  cta_subtitle: 'Przejdź do głównego arkusza i odkryj tysiące produktów',
  cta_button: 'Przejdź do arkusza',
  article_title: 'Najnowsze artykuły',
  article_subtitle: 'Przeczytaj nasze poradniki i artykuły o Kakobuy',
};

export default homePl;